import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
  OAuthErrorEvent,
  OAuthEvent,
  OAuthService,
  OAuthSuccessEvent,
} from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { oAuthConfig } from './core/models/auth.config';
import { LOCAL_STORAGE_KEYS } from './core/models/local-storage-keys';
import { AuthService } from './core/services/auth.service';
import { SpinnerService } from './core/services/spinner.service';
import { LOGIN_TYPES } from './modules/login/models/login-types';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'europair-management-front';
  public spinner$: Observable<boolean> = this._spinnerService.getVisibility$();

  constructor(
    private _oauthService: OAuthService,
    private _router: Router,
    private _authService: AuthService,
    private _translateService: TranslateService,
    private _spinnerService: SpinnerService,
    private titleService: Title
  ) {}

  ngOnInit(): void {
    // this language will be used as a fallback when a translation isn't found in the current language
    this._translateService.setDefaultLang('es');
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this._translateService.use('es');
    if (
      Object.is(
        localStorage.getItem(LOCAL_STORAGE_KEYS.LOGIN_TYPE),
        LOGIN_TYPES.OAUTH
      )
    ) {
      this._oauthService.configure(oAuthConfig);
      this._oauthService.loadDiscoveryDocumentAndLogin().then(() => {
        this.afterLoginNavigateTo();
        if (this._oauthService.getIdentityClaims()) {
          localStorage.setItem(
            LOCAL_STORAGE_KEYS.USER_NAME,
            this._oauthService.getIdentityClaims()['name']
          );
        }
      });
      this._oauthService.events.subscribe((e) =>
        e instanceof OAuthErrorEvent
          ? console.error(e)
          : this.onOAuthSuccessEvent(e)
      );
      this._oauthService.setupAutomaticSilentRefresh();
    }
    this.titleService.setTitle(environment.title);
    this.changeFavicon(environment.favIcon);
  }

  private afterLoginNavigateTo() {
    if (this.isLoginLastAction()) {
      this._router.navigate([this._authService.getRedirectLoginUrl()]);
    }
  }

  private isLoginLastAction(): boolean {
    // Redirect only if login was last action (before app was destroyed)
    const item = localStorage.getItem(
      LOCAL_STORAGE_KEYS.IS_LOGIN_LAST_ACTION
    );
    localStorage.removeItem(LOCAL_STORAGE_KEYS.IS_LOGIN_LAST_ACTION);
    if (item) {
      const isLoginLastAction = JSON.parse(item);
      return isLoginLastAction;
    } else {
      return false;
    }
  }

  private onOAuthSuccessEvent(event: OAuthEvent) {
    console.log(event);
    if (event instanceof OAuthSuccessEvent && event.type !== 'token_received') {
    }
  }

  private changeFavicon(faviconPath: string): void {
    const head = document.getElementsByTagName('head')[0];
    const link = document.getElementById('appFavicon') as HTMLLinkElement;

    // Crea un nuevo elemento link para cambiar el favicon
    const newLink = document.createElement('link');
    newLink.rel = 'icon';
    newLink.type = 'image/x-icon';
    newLink.href = faviconPath;

    // Reemplaza el antiguo link con el nuevo
    head.removeChild(link);
    head.appendChild(newLink);
  }
}
